//
// Copyright (c) 2024 Emplifi
//

define(["marionette", "messaging/messenger", "./template/apiKeyDetailsTemplate.html"], function (
  Marionette,
  Messenger,
  ApiKeyDetailsTemplate,
) {
  "use strict";

  const ApiKeyDetailsView = {};

  ApiKeyDetailsView.view = Marionette.ItemView.extend({
    template: ApiKeyDetailsTemplate,
    triggers: {
      "click #apiKeyCopyValue": "copy:apiKey",
      "click #apiKeyRevokeKey": "revoke:apiKey",
      "click #apiKeyShowValue": "showApiKeyValue",
      "click #deleteApiKey": "delete:apiKey",
    },
    templateHelpers: {
      getDateDisplay: function (date) {
        return Messenger.reqres.request("get:formatted:date:long", date);
      },
      getDateValue: function (date) {
        return Messenger.reqres.request("get:iso:dateUtc", date);
      },
    },
    ui: {
      expiresAt: "#apiKeyExpiresAt",
      knowledgeBase: "#apiKeyKnowledgeBase",
      knowledgeBaseError: "#apiKeyKnowledgeBaseError",
      name: "#apiKeyName",
      nameError: "#apiKeyNameError",
      revoked: "#apiKeyRevoked",
      roleEngine: "#apiKeyRoleEngine",
      roleFordApi: "#apiKeyRoleFordApi",
      roleTopicExportApi: "#apiKeyRoleTopicExportApi",
      roleTopicImportApi: "#apiKeyRoleTopicImportApi",
      roleTopicSearchApi: "#apiKeyRoleTopicSearchApi",
      roleTopicPublishApi: "#apiKeyRoleTopicPublishApi",
      value: "#apiKeyValue",
    },
    clearErrors: function () {
      this.ui.knowledgeBaseError.text("").hide();
      this.ui.nameError.text("").hide();
    },
    getExpiresAt: function () {
      return this.ui.expiresAt.prop("valueAsDate");
    },
    getKnowledgeBase: function () {
      return +this.ui.knowledgeBase.val();
    },
    getName: function () {
      return this.ui.name.val();
    },
    getRevoked: function () {
      return this.ui.revoked.prop("checked");
    },
    getRoleEngine: function () {
      return this.ui.roleEngine.prop("checked");
    },
    getRoleFordApi: function () {
      return this.ui.roleFordApi.prop("checked");
    },
    getRoleTopicExportApi: function () {
      return this.ui.roleTopicExportApi.prop("checked");
    },
    getRoleTopicImportApi: function () {
      return this.ui.roleTopicImportApi.prop("checked");
    },
    getRoleTopicSearchApi: function () {
      return this.ui.roleTopicSearchApi.prop("checked");
    },
    getRoleTopicPublishApi: function () {
      return this.ui.roleTopicPublishApi.prop("checked");
    },
    getValue: function () {
      return this.ui.value.val();
    },
    onShowApiKeyValue: function () {
      this.model.showValue = true;
      this.render();
    },
    showKnowledgeBaseError: function (errorMessage) {
      this.ui.knowledgeBaseError.text(errorMessage).hide().fadeIn();
    },
    showNameError: function (errorMessage) {
      this.ui.nameError.text(errorMessage).hide().fadeIn();
    },
  });

  return ApiKeyDetailsView;
});
